export default {
  track(eventName, props) {
    _require(['metrics'], () => {
      trackable.eventTracker.track(Metrics.Events[eventName], props);
    });
  },
};
